import { JSONPath } from 'jsonpath-plus';
import { choiceIdPaths, fixedIdPath } from './declaration-paths';
/**
 * Checks that the input value should be defined in a oneOf or anyOf block.
 */
export function isDefinedInOneOfOrAnyOf(input, { calmType }, context) {
    if (!input || typeof input !== 'string') {
        return [];
    }
    const fixed = JSONPath({ path: fixedIdPath(calmType), json: context.document.data });
    const inChoices = choiceIdPaths(calmType).flatMap(path => JSONPath({ path, json: context.document.data }));
    const results = [];
    if (fixed.includes(input) && !inChoices.includes(input)) {
        results.push({
            message: `'${input}' is part of a pattern option and must be defined in a oneOf or anyOf block.`,
            path: [...context.path],
        });
    }
    return results;
}
;
//# sourceMappingURL=is-defined-in-oneof-or-anyof.js.map